//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;
var number_inc = false;
var position_counters = 0;


//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	Number.prototype.format = function(n) {
		var r = new RegExp('\\d(?=(\\d{3})+' + (n > 0 ? '\\.' : '$') + ')', 'g');
		return this.toFixed(Math.max(0, Math.floor(n))).replace(r, '$&,');
	};

	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
			document.getElementById('text-js').innerHTML= "Close";
			document.getElementById('header').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
			document.getElementById('text-js').innerHTML= "Menu";
			document.getElementById('header').classList.remove('open');
		
		}
	});
	//menu  tablet nav
	document.getElementById('header__menu-js').addEventListener('click', function(){
		let nav = document.getElementById("nav");
		let toggle = document.getElementById("header__menu-js");
		let menu_title = document.getElementById('menu-title');
		if(!this.classList.contains('active')){
			this.parentElement.classList.add('active');
			this.classList.add('active');
			nav.classList.add('active');
			toggle.classList.add('active');
			menu_title.innerHTML = "Close";

		} else {
			this.classList.remove('active');
			this.parentElement.classList.remove('active');
			nav.classList.remove('active');
			toggle.classList.remove('active');
			menu_title.innerHTML = "menu";
		}
	});


}());
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

	if($('.card__number ').length > 0){
		position_counters = $('.card__number ').offset().top - 500;
		if( st > position_counters && !number_inc ){
			$('.count').each(function () {
				$(this).removeClass('off');
				$('.item').removeClass('off');
				$(this).prop('counter', 0).animate({
					counter: $(this).text()
				}, {
					duration: 2000,
					//easing: 'easeOutExpo',
					step: function (step) {
						$(this).text('' + step.format());
					}
				});
			});
			number_inc = true;
		}
	}

	//mobile change logo
	if(windowWidth < 600){
		var logoUrl = site_url + 'assets/images/logoWhite.png';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
	}
	
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
					var logoUrl = site_url + 'assets/images/logoWhite.png';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);

				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
				var logoUrl = site_url + 'assets/images/logoBlack.png';
				if(windowWidth <= 600){
					var logoUrl = site_url + 'assets/images/logoWhite.png';
				}
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);

			}
		}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

